import { Link } from 'react-router-dom';

export default function Features() {
  const features = [
    {
      icon: 'ri-graduation-cap-line',
      title: '螺旋上升课程体系',
      description: '遵循"感知-体验-创造"到"探究-创新-融通"的进阶路径，确保不同学段学生获得适龄的AI教育',
      color: 'from-blue-500 to-cyan-500',
      stats: '3学段覆盖',
      link: '/features/curriculum-system'
    },
    {
      icon: 'ri-robot-2-line',
      title: '智能体搭建工坊',
      description: '低代码/无代码平台，学生通过配置人设、知识库、技能三要素，快速创建个性化AI应用',
      color: 'from-purple-500 to-pink-500',
      stats: 'RAG技术',
      link: '/features/agent-builder'
    },
    {
      icon: 'ri-eye-line',
      title: '神经网络可视化',
      description: '3D白盒实验室，实时观察神经元激活、权重变化，让抽象的AI原理变得直观可感',
      color: 'from-orange-500 to-red-500',
      stats: 'WebGL渲染',
      link: '/features/neural-network'
    },
    {
      icon: 'ri-shield-check-line',
      title: '多层安全防护',
      description: '内容安全卫士+隐私脱敏层+伦理引导，确保学生在安全合规的环境中探索AI技术',
      color: 'from-green-500 to-emerald-500',
      stats: '100%合规',
      link: '/features/security'
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: 'AI素养评价体系',
      description: '过程性+表现性评价，自动生成思维深度、实践能力、伦理意识的雷达图成长档案',
      color: 'from-indigo-500 to-blue-500',
      stats: '全程记录',
      link: '/features/assessment'
    },
    {
      icon: 'ri-team-line',
      title: '教师智教赋能',
      description: '智能教案生成、课堂控制台、屏幕监控，解决老师"不会教、难管理、难评价"的痛点',
      color: 'from-yellow-500 to-orange-500',
      stats: '一键分发',
      link: '/features/teacher-empowerment'
    }
  ];

  return (
    <section id="features" className="py-24 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full mb-4">
            <i className="ri-star-line"></i>
            <span className="text-sm font-semibold">CORE FEATURES</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            六大核心功能
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            基于《指导意见》要求，打造覆盖教学全流程的智能化教育平台
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <Link
              key={index}
              to={feature.link}
              className="group bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-blue-200 hover:-translate-y-2 cursor-pointer"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${feature.color} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-xl font-bold text-gray-900">{feature.title}</h3>
                <span className="text-xs font-semibold text-blue-600 bg-blue-50 px-3 py-1 rounded-full whitespace-nowrap">
                  {feature.stats}
                </span>
              </div>
              
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>

              <div className="mt-6 flex items-center text-blue-600 font-semibold group-hover:translate-x-2 transition-transform">
                <span className="text-sm whitespace-nowrap">了解详情</span>
                <i className="ri-arrow-right-line ml-2"></i>
              </div>
            </Link>
          ))}
        </div>

        {/* Stats Bar */}
        <div className="mt-20 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl p-12 text-white">
          <div className="grid md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-5xl font-bold mb-2">15+</div>
              <div className="text-blue-200">功能模块</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">4</div>
              <div className="text-blue-200">核心子系统</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">3</div>
              <div className="text-blue-200">安全防护层</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">100%</div>
              <div className="text-blue-200">政策对标</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
